import React from "react";
import type { AdminQuest } from "common/types/questManagement.type";

interface StatusQuestModalProps {
  quest: AdminQuest | null;
  isUpdating: boolean;
  errorMessage: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const StatusQuestModal = ({
  quest,
  isUpdating,
  errorMessage,
  onCancel,
  onConfirm,
}: StatusQuestModalProps) => {
  if (!quest) return null;

  const isFreezing = quest.is_active;
  const actionLabel = isFreezing ? "凍結する" : "凍結解除";
  const confirmationMessage = isFreezing
    ? "このクエストを凍結しますか？"
    : "このクエストの凍結を解除しますか？";

  return (
    <div className="motion-safe:animate-modal-fade absolute inset-0 z-40 flex items-center justify-center bg-white/70 px-[24px]">
      <div className="w-full max-w-[460px] rounded-[6px] border border-[#1b4b86] bg-white p-[28px] shadow-[0_8px_24px_rgba(0,0,0,0.18)]">
        <h2 className="border-l-[4px] border-[#1b4b86] pl-[12px] text-[20px] font-bold leading-[1.6] text-[#1b4b86]">
          クエスト状態変更
        </h2>

        <p className="mt-[24px] text-[15px] leading-[1.8] text-black">
          「{quest.title}」
          <br />
          {confirmationMessage}
        </p>

        {errorMessage ? (
          <p className="mt-[16px] whitespace-pre-line text-[13px] leading-[1.6] text-[#de3c3f]">
            {errorMessage}
          </p>
        ) : null}

        <div className="mt-[28px] grid grid-cols-2 gap-[15px]">
          <button
            className="flex h-[46px] items-center justify-center rounded-[6px] bg-[#eef5fa] text-[16px] font-bold leading-[1.6] text-[#1b4b86] disabled:opacity-50"
            disabled={isUpdating}
            onClick={onCancel}
            type="button"
          >
            キャンセル
          </button>
          <button
            className="flex h-[46px] items-center justify-center rounded-[6px] bg-[#1b4b86] text-[16px] font-bold leading-[1.6] text-white disabled:opacity-50"
            disabled={isUpdating}
            onClick={onConfirm}
            type="button"
          >
            {isUpdating ? "変更中..." : actionLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusQuestModal;
